module.exports = __webpack_public_path__ + "img/1-hero-section-model-3r.a1dbeefe.jpeg";